<form #form="ngForm" class="cliente-logistica-form" novalidate *ngIf="entity">
  <sgt-accordion [settings]="{ isCollapsed: true }">
    <h6 header class="m-0">Frete</h6>

    <div class="row">
      <div class="form-group col-12">
        <label for="tipoFrete" class="col-form-label">Tipo do Frete</label>
        <sgt-tipo-frete-select
          [(ngModel)]="entity.tipoFrete"
          name="tipoFrete"
          id="tipoFrete"
          [disabled]="!canEdit"
          #tipoFrete="ngModel">
        </sgt-tipo-frete-select>
        <div class="form-text text-muted">
          {{entity.tipoFrete | tipoFreteDescricao}}
        </div>
        <div class="form-text text-muted">
          Tipo de frete preferencial do cliente
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12 mb-0">
        <label class="col-form-label">Transportadora</label>
        <sgt-typeahead-transportadora [(ngModel)]="entity.transportadora" name="transportadora" id="transportadora"
          #transportadora="ngModel" [ngControl]="transportadora" [situacao]="transportadoraSituacaoAtiva.id"
          (typeaheadChange)="onChangeTransportadora($event)"
          [disabled]="!canEdit"
          [readonly]="!canEdit">
        </sgt-typeahead-transportadora>
        <div class="form-text text-muted">
          Transportadora preferencial do cliente
        </div>
      </div>
    </div>
  </sgt-accordion>

  <sgt-accordion [settings]="{ isCollapsed: true }">
    <h6 header class="m-0">Políticas de Logística</h6>

    <div class="row">
      <div class="form-group col-12">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="entity.aplicaMultaPorAtrasoLogistico"
            name="aplicaMultaPorAtrasoLogistico"
            id="aplicaMultaPorAtrasoLogistico"
            [disabled]="!canEdit"
          >
          <label class="custom-control-label" for="aplicaMultaPorAtrasoLogistico">Aplica multa por atraso logístico</label>
        </div>
        <p class="form-text text-muted">Indica se o cliente aplica multa quando ocorre atraso na entrega dos produtos</p>
      </div>
    </div>

    <div class="row cliente-logistica-form__politicas__normas-paletizacao">
      <div class="form-group col-12">
        <label for="normasPaletizacao" class="col-form-label">Normas de Paletização</label>
        <textarea
          class="form-control"
          [(ngModel)]="entity.normasPaletizacao"
          name="normasPaletizacao"
          id="normasPaletizacao"
          rows="3"
          sgtAutosize
          [disabled]="!canEdit"
        ></textarea>
        <p class="form-text text-muted">Descreva as normas e exigências do cliente para paletização dos produtos, como altura máxima, peso por pallet, tipo de embalagem ou disposição das cargas</p>
      </div>
    </div>
  </sgt-accordion>

  <sgt-accordion [settings]="{ isCollapsed: true }">
    <h6 header class="m-0">Shelf Life</h6>

    <div class="row cliente-logistica-form__shelf-life__possui">
      <div class="form-group col-12">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="entity.possuiRegraShelfLife"
            name="possuiRegraShelfLife"
            id="possuiRegraShelfLife"
            [disabled]="!canEdit"
          >
          <label class="custom-control-label" for="possuiRegraShelfLife">Possui regra de Shelf Life</label>
        </div>
        <p class="form-text text-muted">Indica se o cliente exige um prazo mínimo de validade (shelf life) para os produtos recebidos</p>
      </div>
    </div>

    <div class="row cliente-logistica-form__shelf-life__perc" *ngIf="entity.possuiRegraShelfLife">
      <div class="form-group col-12">
        <label for="percShelfLife" class="col-form-label">Percentual mínimo de Shelf Life</label>
        <div class="input-group">
          <sgt-decimal2
              [(ngModel)]="entity.percShelfLife"
              name="percShelfLife"
              id="percShelfLife"
              #percShelfLife="ngModel"
              [ngControl]="percShelfLife"
              [min]="0"
              [max]="100"
              [digits]="0"
              [required]="canEdit"
              [disabled]="!canEdit">
          </sgt-decimal2>
          <div class="input-group-append">
            <span class="input-group-text">
              %
            </span>
          </div>
        </div>
        <div class="form-text text-muted">Percentual mínimo de vida útil restante exigido pelo cliente no ato do recebimento</div>
        <sgt-form-control-error
          *ngIf="percShelfLife.errors && percShelfLife.errors.required && percShelfLife.dirty"
          msgError="O percentual mínimo de shelf life é obrigatório">
        </sgt-form-control-error>
      </div>
    </div>
  </sgt-accordion>

  <sgt-accordion [settings]="{ isCollapsed: true }">
    <div header>
      <h6>Observações de Logística</h6>
      <span *ngIf="configCliente?.mensagemInformativaObservacoesLogistica" [innerHTML]="configCliente?.mensagemInformativaObservacoesLogistica"></span>
    </div>

    <textarea
      class="form-control"
      [(ngModel)]="entity.observacoesLogistica"
      name="observacoesLogistica"
      id="observacoesLogistica"
      rows="3"
      sgtAutosize
      [disabled]="!canEdit"
    ></textarea>
  </sgt-accordion>
</form>
